export type Configuration = {
  ignoreOutOfStock: boolean;
};

export const currentConfiguration: Configuration = {
  ignoreOutOfStock: true, // Set to true to disable out-of-stock restrictions
};
